const Constants = {
  route: {
    baseUrl: typeof window !== "undefined" ? window.location.origin : "",
    onboardingPage: "/onboarding",
    globalHome: "/",
    silentRedirectUrl: typeof window !== "undefined" ? `${window.location.origin}/oauth` : ""
  },
  tokenRenewalOffsetSeconds: 60
};
const LAST_TENANT_ID = "lastTenantId";
const LAST_WORKSPACE_ID = "lastWorkspaceId";
const LAST_EXPERIMENTATION_GROUP = "lastExperimentationGroup";
const MSFT_TENANT_ID = "72f988bf-86f1-41af-91ab-2d7cd011db47";
const AME_TENANT_ID = "33e01921-4d64-4f8c-a055-5bdaffd5e33d";
const PME_TENANT_ID = "975f013f-7f24-47e8-a7d3-abc4752bf346";
const GITHUB_TENANT_ID = "398a6654-997b-47e9-b12b-9515b896b4de";
const TORUS_TENANT_ID = "cdc5aeea-15c5-4db6-b079-fcadd2505dc2";
const NUANCEHCE_TENANT_ID = "ed5693bc-117f-4001-a14c-5f50a530d5df";
const APPNEXUS_TENANT_ID = "e057207a-0899-4ebf-934e-58388978431d";
const MSFTGREEN_TENANT_ID = "68cd85cc-e0b3-43c8-ba3c-67686dbf8a67";
const TenantNamesById = {
  [MSFT_TENANT_ID]: "Microsoft",
  [AME_TENANT_ID]: "AME",
  [PME_TENANT_ID]: "PME",
  [GITHUB_TENANT_ID]: "GitHub",
  [TORUS_TENANT_ID]: "Torus",
  [NUANCEHCE_TENANT_ID]: "Nuance HCE",
  [APPNEXUS_TENANT_ID]: "Appnexus",
  [MSFTGREEN_TENANT_ID]: "MSFTGreen"
};
export {
  AME_TENANT_ID,
  APPNEXUS_TENANT_ID,
  Constants,
  GITHUB_TENANT_ID,
  LAST_EXPERIMENTATION_GROUP,
  LAST_TENANT_ID,
  LAST_WORKSPACE_ID,
  MSFTGREEN_TENANT_ID,
  MSFT_TENANT_ID,
  NUANCEHCE_TENANT_ID,
  PME_TENANT_ID,
  TORUS_TENANT_ID,
  TenantNamesById
};
//# sourceMappingURL=MSAL.constants.js.map
